// src/components/pwa/steps/common/PlaceholderScreen.js
// Generic placeholder used for screens under construction.

import React from 'react';
import styled from 'styled-components';

const Outer = styled.div`
  background: #f0f2f5;
  min-height: 100dvh;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100dvh - 70px);
  padding-top: 70px;
  gap: 16px;
  text-align: center;
`;

const IconCircle = styled.div`
  width: 72px;
  height: 72px;
  background: #1f2937;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
`;

const Sub = styled.p`
  font-size: 15px;
  color: #6b7280;
  margin: 0;
  max-width: 360px;
`;

const Badge = styled.span`
  background: #1f2937;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 16px;
  border-radius: 20px;
  letter-spacing: 1px;
`;

const PlaceholderScreen = ({ title, icon, description, comingSoon = false }) => {
  return (
    <Outer>
      <Inner>
        <IconCircle>{icon}</IconCircle>
        <Title>{title}</Title>
        <Sub>{description}</Sub>
        {comingSoon && <Badge>COMING SOON</Badge>}
      </Inner>
    </Outer>
  );
};

export default PlaceholderScreen;
